// Catégories de rendez-vous — ordre d'affichage + libellés UI
export const APPOINTMENT_CATEGORIES = [
    { key: "vaccinations",     label: "Vaccinations",                          short: "Vaccins",       icon: "Syringe" },
    { key: "prevention",       label: "Prévention & dépistages",               short: "Dépistages",    icon: "Activity" },
    { key: "conseils",         label: "Consultations & conseils pharmaceutiques", short: "Consultations", icon: "Stethoscope" },
    { key: "complementaires",  label: "Médecines complémentaires",             short: "Médecines",     icon: "Leaf" },
    { key: "autres",           label: "Autres services",                       short: "Autres",        icon: "Sparkles" },
];

export const CATEGORY_LABEL = Object.fromEntries(
    APPOINTMENT_CATEGORIES.map((c) => [c.key, c.label])
);
